import React from "react";

function Loading() {
  return (
    <div className="loader-container">
      <div className="loader">
        <p className="loader-p">Loading...</p>
      </div>
    </div>
  );
}

export default Loading;
